module.exports = __webpack_public_path__ + "img/PiYo.b0c1af7d.jpeg";